@@include('../../plugins/swiper.v12.1.2/swiper-bundle.min.js')
@@include('../../plugins/nouislider.v15.8.1/nouislider.min.js')
